<template>
  <div class="mytesting">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="getMyWorkEvent"
        class="content-collect"
      >
        <div
          class="task-list"
          v-for="(item, index) in list"
          :key="index"
          :data-id="item.test_id"
          @click="goto"
        >
          <div class="task-test-name">
            <div class="test-title">{{ item.test_name }}</div>
            <span v-if="item.status == 2" class="checking">批阅中</span>
            <span v-if="item.status == 3" class="checked">已批阅</span>
          </div>
          <div class="task-test-content">
            <div v-if="item.course_name == ''">暂未关联课程</div>
            <div v-else>{{ item.course_name }}</div>
            <div>交卷时间:{{ item.create_date }}</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { List, PullRefresh } from "vant";
//Vue.use(Form);
export default {
  name: "index",
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  data() {
    return {
      total: 0,
      page: 1,
      pageSize: 14,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      test_id: 0,
    };
  },
  mounted() {
    this.util.hideOptionMenu();
    this.getMyWorkEvent(1);
  },
  methods: {
    onRefresh() {
      this.getMyWorkEvent(1);
    },
    goto(e) {
      this.$router.push(
        this.util.urlPrefix +
          "/testing/answered?test_id=" +
          e.currentTarget.dataset.id +
          "&token=" +
          this.util.token
      );
    },
    getMyWorkEvent(page) {
      var _self = this;
      if (!page) {
        var pageNo = this.page;
        pageNo += 1;
        this.page = pageNo;
      } else {
        this.page = page;
      }
      this.util.server.mini_testing.mytesting({
        data: {
          page: this.page,
          pagesize: this.pageSize,
        },
        callback: (res) => {
          const { code, data, msg } = res;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if (code == 1) {
            console.log(data);
            //赋值总数量
            if (data.total) {
              this.total = data.total;
            }
            //1.如果有数据
            if (data.items && data.items.length > 0) {
              let templist = [];
              if (page == 1) {
                templist = data.items;
              } else {
                //如果翻页 则在数组追加数据
                templist = this.list.concat(data.items);
              }
              for (var i = 0; i < templist.length; i++) {
                templist[i].open_text = 1;
              }
              this.list = templist;

              //判断是否存在下一页
              this.loading = false;

              if (this.total * 1 == this.list.length) {
                this.finished = true;
              }
            } else {
              //2.无数据
              //如果当前页为第一页 则设置页面数据为空数组
              if (page == 1) {
                this.list = [];
                this.finished = true;
                this.loading = false;
              }
            }
          } else {
            this.util.showToast({
              message: msg,
            });
          }
        },
      });
    },
  },
};
</script>

<style scoped>
body {
  background-color: #ffffff;
}

.task-list {
  margin: 15px 15px 0px 15px;
  line-height: 35px;
}

.task-test-name {
  display: flex;
}

.task-test-name .test-title {
  flex: 1;
  width: 100%;
  font-size: 18px;
}

.task-test-name span {
  width: 50px;
}
.task-test-name span.checking {
  color: #fe9500;
}
.task-test-name span.checked {
  color: #42b983;
}
.task-test-content {
  color: #aaa;
}
</style>
